module.exports = __webpack_public_path__ + "static/media/p4_face.3aa52c91.png";